import { AlertTriangle } from 'lucide-react';

interface RateLimitBannerProps {
  /** When set, an amber warning banner is shown. Hidden when empty/null. */
  message?: string | null;
}

export function RateLimitBanner({ message }: RateLimitBannerProps) {
  if (!message?.trim()) return null;

  return (
    <div
      role="alert"
      className="mb-4 flex w-full items-start gap-3 rounded-lg border border-warning/30 bg-warning-soft px-4 py-3 text-sm text-warning"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-warning" aria-hidden />
      <p className="min-w-0 flex-1 leading-snug">{message}</p>
    </div>
  );
}
